import { Button } from "@/components";
import clsx from "clsx";
import styles from "./styles.scss";
import { Moon, Sun } from "@/assets/icons";
import { themeControl } from "@/utils";
import { ThemeType } from "@/constants";
import { useEffect, useState } from "react";

export const ThemeSwitcher = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const { isDark, setTheme, getCurrentTheme } = themeControl();

  useEffect(() => {
    setIsDarkTheme(isDark());
  }, [isDark]);

  const handleToggleThemeMode = () => {
    const updatedTheme =
      getCurrentTheme() === ThemeType.Dark ? ThemeType.Light : ThemeType.Dark;

    setTheme(updatedTheme);
    setIsDarkTheme(isDark());
  };

  return (
    <Button
      className={clsx(styles.iconWrapper)}
      onClick={handleToggleThemeMode}
      icon={isDarkTheme ? <Sun /> : <Moon />}
    />
  );
};
